export const pagesDataA = [
  {
    id: 1,
    title: "Die Wissenschaft der natürlichen Verjüngerung",
    subtitle: "Vitalität ohne Grenzen - Alter ohne Bedeutung",
    image: require("../assets/width_1024.webp"),
  },
  {
    id: 2,
    title: "Dein biologisches Alter entsteht in Deiner Küche",
    subtitle: "Das Geheimnis der Re-Aging Küche",
    image: require("../assets/width_478.webp"),
  },
  {
    id: 3,
    title:
      "Rhythmus, Atmung, Bewegung - die Grundlage für jügendliche Vitalität",
    subtitle: "Aktiviere die Programme der Langlebigkeit",
    image: require("../assets/width_929.webp"),
  },
  {
    id: 4,
    title:
      "Was Du denkst wird Biochemie - jeder Gedanke ist ein Impuls, der Deine Zellen formt",
    subtitle: "Im Geist beginnt, was im Körper heilt",
    image: require("../assets/width_582.webp"),
  },
  {
    id: 5,
    title: "Wissenschaftlich fundierte Programme",
    subtitle: "Du bist der Schöpfer Deiner Biologie",
    image: require("../assets/width_800_1.webp"),
  },
  {
    id: 6,
    title: "Re-Aging - die Kunst des gesunden Alterns",
    subtitle: "Nimm Einfluss auf den Code des Lebens",
    image: require("../assets/width_629.webp")
  },
  {
    id: 7,
    title: "Re-Metabolic – das Programm für metabolischen Neubeginn",
    subtitle: "Stoffwechsel neu denken - Körper neu erleben",
    image: require("../assets/width_800_2.webp")
  },
  {
    id: 8,
    title: "Re-Brain – ein Spezialprogramm für maximale kognitive Leistung",
    subtitle: "Klar denken. Schnell entscheiden. Besser führen.",
    image: require("../assets/width_1280.webp")
  },
];

export const pagesDataB = [
  {
    id: 1,
    title: `Willkommen bei Re-Aging – 
        Ihrem Partner für wissenschaftlich fundierte Programme zur Vitalisierung und Verjüngung`,
    paragraph1: `Unsere Konzepte basieren auf neuesten Erkenntnissen aus Ernährungsmedizin, 
        Epigenetik und Psychologie und sind darauf ausgerichtet, 
        regenerative Prozesse im Körper zu aktivieren, die Zellgesundheit zu fördern und das biologische Alter messbar zu reduzieren.`,
    paragraph2: ``,
    paragraph3: ``,
  },
  {
    id: 2,
    title: `Dein biologisches Alter entsteht in Deiner Küche`,
    paragraph1: `Unsere Methode kombiniert auf professionelle Weise die Prinzipien der ketogenen Diät, 
        des Scheinfastens und des Intervallfastens,
        ergänzt durch die nährstoffreichen Sirtfoods. Diese einzigartige Synthese stellt einen innovativen Ansatz dar.`,
    paragraph2: `Die ketogene Diät versetzt den Körper in einen Zustand der Ketose,
        wodurch Fett effizient verbrannt wird und geistige Klarheit gefördert wird.
        Das Scheinfasten ermöglicht Ihnen, die Vorteile des Fastens zu genießen,
        ohne auf alle Nahrungsmittel zu verzichten, während das Intervallfasten strategische Essenszeiten bietet, 
        um den Stoffwechsel anzukurbeln. Zudem sorgt die Auswahl an Sirtfoods dafür,
        dass Sie nicht nur abnehmen, sondern auch Ihre Energie und Vitalität steigern können.`,
    paragraph3: `Diese Methoden basieren auf wissenschaftlich belegten Studien und wurden mehrfach erprobt.
        Mit unserem Programm unterstützen wir Sie dabei, Ihre Gesundheitsziele zu erreichen und sich in 
        Ihrem Körper wieder wohlzufühlen. Starten Sie noch heute Ihre Reise zu mehr Lebensqualität!`,
  },
  {
    id: 3,
    title: `Re-Aging - aktive Rückgewinnung von Vitalität und Jugendlichkeit auf Zellebenen`,
    paragraph1: `Re-Aging steht für eine neue Generation der Gesundheits- und Verjüngungsprogramme.
        Das Konzept vereint neueste Erkenntnisse aus der Epigenetik,
        Ernährungsmedizin und Neuropsychologie zu einem ganzheitlichen Verjüngungskonzept auf Premium-Niveau.`,
    paragraph2: `Unser dreisäuliger Ansatz basiert auf präzise abgestimmter Ernährung & Fastenstrategien,
        mentaler Balance & Resilienzförderung und körperliche Regeneration & Tiefenentspannung.`,
    paragraph3: `Die Besonderheit: Wir kombinieren diese bewährten Elemente zu einem ganzheitlich-personalisierten Programm,
        das gezielt auf Ihre biologischen Prozesse wirkt – mit dem Ziel,Ihr Wohlbefinden zu steigern und
        Ihr biologisches Alter sichtbar zu reduzieren. Re-Aging ist kein kurzfristiger Trend – sondern eine exklusive Investition 
        in Ihre langfristige Vitalität. Wissenschaftlich fundiert. Persönlich abgestimmt.`,
  },
  {
    id: 4,
    title: `Re-Metabolic – ein Reset für Körper und Bewusstsein`,
    paragraph1: `Re-Metabolic ist Teil des Re-Aging-Konzepts und kombiniert modernste Erkenntnisse aus Ernährungsmedizin,
        Epigenetik und Zellbiologie mit den bewährten Re-Aging-Prinzipien.
        Ziel ist die Aktivierung des Stoffwechsels, gesunde Gewichtreduktion und die nachhaltige Gewichtsregulation.`,
    paragraph2: `Neben den bewährten Re-Aging-Strategien wie Scheinfasten, Sirtfood-Aktivierung und zellregenerierender Ernährung setzen wir hier auch auf die wissenschaftlich bewährte Hypnose-Technik. Wir identifizieren die
        tieferen Ursachen der Gewichtszunahme und lösen sie gezielt auf – körperlich, stoffwechselbezogen und mental.`,
    paragraph3: `Hypnose-Technik. Wir identifizieren die tieferen Ursachen der Gewichtszunahme und lösen sie gezielt
        auf – körperlich, stoffwechselbezogen und mental.
        So entsteht ein ganzheitlicher Re-Metabolic-Reset: weniger Gewicht, mehr Energie und ein dauerhaft gesunder Stoffwechsel.`,
  },
  {
    id: 5,
    title: `Re-Brain – das Brain-Refresh Programm für maximale kognitive Leistung`,
    paragraph1: `Das Programm Re-Brain ist ein Spezialprogramm, das gezielt für strategische Meetings,
        Führungskräfte-Retreats und hochkonzentrierte Arbeitsphasen 
        in Unternehmen entwickelt wurde um die Denkprozesse gezielt zu unterstützen.`,
    paragraph2: `Ziel ist es, durch kurzzeitoptimierte Brainfood-Konzepte, gezielte Ernährungsimpulse,
        neuroaktive Mikronährstoffe, Aktivierungsphasen und mental-biologische Reset-Techniken die Gehirnaktivität der
        Teilnehmenden signifikant zu steigern. Basierend auf aktuellen Erkenntnissen
        der Ernährungsforschung und Epigenetik kombiniert das Programm praxiserprobte Maßnahmen, die die mentale
        Klarheit erhöhen und die kognitive Ermüdung verzögern.`,
    paragraph3: `Brain Refresh ist kein Cateringprogramm – es ist ein integratives Performance-Modul für Firmen,
        die ihre wertvollste Ressource – die geistige Leistungsfähigkeit ihrer Teams – zielgerichtet stärken wollen. `,
  },
];

export const pagesDataC = [
  {
    id: 1,
    title: "Die drei Säulen",
    text1: "Ernährungsstrategien für optimale Vitalität und Gesundheit.",
    text2:
      "Bewegung, Entspannung und Körperarbeit für körperliche und geistige Balance.",
    text3:
      "Mentale Techniken zur Stärkung der Resilienz und des Wohlbefindens.",
    imageLeft: require("../assets/width_478.webp"),
    imageCenter: require("../assets/width_800.webp"),
    imageRight: require("../assets/width_582.webp"),
  },
  {
    id: 2,
    title: "Wissenschaftlich fundierte Programme",
    text1: "Re-Aging - die Kunst des gesunden Alterns",
    text2: "Re-Metabolic – das Programm für metabolischen Neubeginn",
    text3: "Re-Brain – ein Spezialprogramm für maximale kognitive Leistung",
    imageLeft: require("../assets/width_629.webp"),
    imageCenter: require("../assets/width_800_2.webp"),
    imageRight: require("../assets/width_1280.webp"),
  },
];
